import "antd/dist/reset.css";
import "./styles/App.css";
import "./styles/footer.css";
import "mapbox-gl/dist/mapbox-gl.css";
import Router from "./routers/Router";
import { AuthProvider } from "./contexts/AuthContext";


function App() {
  return (
    <AuthProvider>
      <div className="app-layout">
        <Router />
      </div>
    </AuthProvider>
  );
}

export default App;
